import { IDataCountryResourceShortProps } from '../../../props/data/geographics/countries';
import Request from './../../request';

// import props

const DataCountryService = {
    retrieve: async (qs?: string): Promise<IDataCountryResourceShortProps[]> => {
        try {
            const results = await Request.get(`/api/data/geographics/countries?${qs || ""}`);
            return results;
        } catch (e) {
            throw (e);
        }
    }
};

export default DataCountryService;